/**
 * Running effectiveness: RE = speed [m/s] / (power [W] / body mass [kg]) = v / (W/kg).
 * Aligns with common definitions (e.g. Runalyze). Requires power data (e.g. Stryd).
 */
export function computeRunningEffectiveness(speedMps, watts, weightKg) {
  const v = parseFloat(speedMps);
  const p = parseFloat(watts);
  const m = parseFloat(weightKg);
  if (!(v > 0) || !(p > 0) || !(m > 0)) return null;
  const wattsPerKg = p / m;
  if (!(wattsPerKg > 0)) return null;
  return v / wattsPerKg;
}

/** Matches server vo2maxService default when profile weight is missing. */
export const DEFAULT_ATHLETE_WEIGHT_KG = 70;

export function resolveAthleteWeightKg(activity) {
  const w = parseFloat(activity?.athlete_weight_kg);
  if (Number.isFinite(w) && w > 0) return w;
  return DEFAULT_ATHLETE_WEIGHT_KG;
}
